"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var HeaderFlexPane_1 = require("./HeaderFlexPane");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var owa_options_view_1 = require("owa-options-view");
var mobx_react_1 = require("mobx-react");
var SettingsPane = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsPane, _super);
    function SettingsPane() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SettingsPane.prototype.render = function () {
        return (React.createElement(HeaderFlexPane_1.default, { title: function () { return owa_options_strings_1.default.optionsFlex_title; }, content: React.createElement(owa_options_view_1.QuickOptions, { onDismiss: this.props.onDismiss }), onDismiss: this.props.onDismiss }));
    };
    SettingsPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], SettingsPane);
    return SettingsPane;
}(React.Component));
exports.default = SettingsPane;
//# sourceMappingURL=SettingsPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/components/SettingsPane.js
// module id = 6212
// module chunks = 38